import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=4bdaeeec&"
import script from "./DynamicForm.vue?vue&type=script&lang=js&"
export * from "./DynamicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TurnstileCaptcha: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/base/TurnstileCaptcha.vue').default})
